import jwtDecode from 'jwt-decode';
import update from 'immutability-helper';

import * as UserUtils from '../utils/User';
import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    isShowRegModal: false,
    isShowAuthModal: false,
    isShowWrongDataMessage: false,
    isShowRestorePasswordFirstStep: false,
    isShowRestorePasswordSecondStep: false,
    currentUser: {
        email: '',
        userId: '',
        favorites: [],
        lastName: '',
        firstName: '',
        accessToken: UserUtils.getAccessToken(),
        permissions: []
    }
});

export default (state = initialState(), action) => {
    let jwtClaims;
    let currentUser;
    let accessToken;

    switch (action.type) {
        case ActionTypes.SHOW_AUTH_MODAL:
            return {...state, isShowAuthModal: action.payload, isShowRegModal: false};
        case ActionTypes.CHANGE_VISIBLE_RESTORE_PASSWORD_FIRST_STEP_MODAL:
            return {...state, isShowRestorePasswordFirstStep: action.payload};
        case ActionTypes.CHANGE_VISIBLE_RESTORE_PASSWORD_SECOND_STEP_MODAL:
            return {...state, isShowRestorePasswordSecondStep: action.payload};
        case ActionTypes.SHOW_REG_MODAL:
            return {...state, isShowRegModal: action.payload, isShowAuthModal: false, isShowWrongDataMessage: false};
        case ActionTypes.REGISTER:
        case ActionTypes.LOGIN_EMAIL:
        case ActionTypes.LOGIN_FACEBOOK:
            accessToken = action.payload;
            jwtClaims = jwtDecode(accessToken);

            currentUser = update(state.currentUser, {
                email: {$set: jwtClaims.email},
                userId: {$set: jwtClaims.userId},
                accessToken: {$set: accessToken},
                lastName: {$set: jwtClaims.lastName},
                firstName: {$set: jwtClaims.firstName},
                isAdmin: {$set: jwtClaims.admin},
                permissions: {$set: jwtClaims.permissions},
            });
            UserUtils.setAccessToken(accessToken);

            return {
                ...state,
                isShowRegModal: false,
                isShowAuthModal: false,
                currentUser: currentUser,
                isShowWrongDataMessage: false
            };
        case ActionTypes.LOGOUT:
            accessToken = action.payload;
            currentUser = update(state.currentUser, {
                accessToken: {$set: accessToken}
            });
            UserUtils.setAccessToken(accessToken);

            return {...state, currentUser: currentUser};
        case ActionTypes.CHANGE_FAVORITES:
            let index = state.currentUser.favorites.indexOf(action.payload);
            if (index > -1) {
                currentUser = update(state.currentUser, {
                    favorites: {$splice: [[index, 1]]}
                });
            } else {
                currentUser = update(state.currentUser, {
                    favorites: {$push: [action.payload]}
                });
            }
            return {...state, currentUser: currentUser};
        case ActionTypes.SHOW_WRONG_DATA_MESSAGE:
            return {...state, isShowWrongDataMessage: action.payload};
        case ActionTypes.SET_USER_INFO:
            accessToken = action.payload;
            jwtClaims = jwtDecode(accessToken);

            currentUser = update(state.currentUser, {
                email: {$set: jwtClaims.email},
                userId: {$set: jwtClaims.userId},
                accessToken: {$set: accessToken},
                lastName: {$set: jwtClaims.lastName},
                firstName: {$set: jwtClaims.firstName},
                isAdmin: {$set: jwtClaims.admin},
                permissions: {$set: jwtClaims.permissions},
            });
            return {...state, currentUser: currentUser};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/User.js